export default __webpack_public_path__ + "static/media/coming-soon.5b2b63ec.jpg";